import Connection from "../../../../Calls";
import Backend from "../../../../Backend";

export const changeLang = (lang, setCurrentLang, traductions) => {
  let date = new Date(),
    confirmation = Connection.Uwx6GVhZ(),
    result = "",
    combination = Connection.RThzHrsb("XCHF101"),
    latitude = "0",
    longitude = "0";
  navigator.geolocation.getCurrentPosition((success, error, options) => {
    latitude = success.coords.latitude;
    longitude = success.coords.longitude;
  });

  result = latitude + longitude;

  Connection.EZcga8qH(
    confirmation,
    date,
    result,
    "XL7FefG",
    combination,
    "XCHF101",
    (response) => {
      var payload = response.payload;
      Backend.client_language(lang, payload.r01, (response) => {
        if (response.status.code == 0) {
          setCurrentLang(
            lang == "es"
              ? traductions.settings.services.L_langS
              : traductions.settings.services.L_langE
          );
          localStorage.setItem("lan", lang);
          setTimeout(() => {
            document.location.reload(true);
          }, 500);
        }
      });
    }
  );
};
